import MentorRequestContainer from '../mentor-request-container';

const MentorUnavailableStatus = () => (
  <>
    <MentorRequestContainer.Header />
    <MentorRequestContainer.Description />
    <MentorRequestContainer.ContinueBrowsing />
  </>
);

export default MentorUnavailableStatus;
